import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  TextField,
  Grid,
  Divider,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  IconButton,
  OutlinedInput
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { messageToastType_const } from 'src/app/constant/config';
import { showGlobalToast } from 'src/features/uiSlice';
import { getListAgencies } from 'src/features/agencySlice';
import { getListUsers } from 'src/features/userSlice';

const OrderDialog = ({
  open,
  onClose,
  isEditing,
  editOrderId,
  form,
  setForm,
  devices,
  setDevices,
  tabForm,
  setTabForm,
  fetchType,
  setFetchType,
  suggestionLoading,
  setSuggestionLoading,
  selectedUser,
  setSelectedUser,
  setSelectedImages,
  handleCreateOrder,
  handleFetchUserInfo,
  handleAutocompleteSearch,
  handleAddDevice,
  handleRemoveDevice,
  handleDeviceChange,
  listDeviceType,
  listAgencies,
  listUsers,
  formatMoney,
  formatInputMoney,
  parseInputMoney
}) => {
  const dispatch = useDispatch();
  const captureRef = useRef(null);

  const handleCaptureScreenshot = async () => {
    if (!captureRef.current) {
      dispatch(
        showGlobalToast({
          message: 'Không tìm thấy vùng cần chụp!',
          type: messageToastType_const.warning
        })
      );
      return;
    }
    dispatch(
      showGlobalToast({
        message: 'Đang xử lý chụp màn hình, vui lòng đợi...',
        type: messageToastType_const.info
      })
    );
    try {
      const element = captureRef.current;

      const dataUrl = await toPng(element, {
        cacheBust: true,
        backgroundColor: '#ffffff',
        pixelRatio: 2,
        filter: node => {
          if (node.classList && node.classList.contains('no-capture')) {
            return false;
          }
          return true;
        },
        style: {
          padding: '24px',
          borderRadius: '0px'
        }
      });

      const filename = `don_hang_${form.fullName ||
        form.account ||
        'moi'}_${moment().format('YYYYMMDD_HHmmss')}.png`;
      saveAs(dataUrl, filename);

      dispatch(
        showGlobalToast({
          message: 'Đã lưu ảnh phiếu bán hàng!',
          type: messageToastType_const.success
        })
      );
    } catch (error) {
      console.error('Capture screenshot error:', error);
      dispatch(
        showGlobalToast({
          message: 'Lỗi khi chụp màn hình: ' + error.message,
          type: messageToastType_const.error
        })
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" style={{ fontWeight: 700, color: '#1a1f36' }}>
            {isEditing ? `Sửa phiếu: ${editOrderId}` : '+ Thông tin đơn hàng'}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<PhotoCameraIcon />}
            onClick={handleCaptureScreenshot}
            style={{ fontWeight: 600, textTransform: 'none' }}
          >
            Chụp ảnh phiếu
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box pt={1} pb={1} ref={captureRef} style={{ backgroundColor: '#fff' }}>
          <Tabs
            value={tabForm}
            onChange={(_, v) => {
              setTabForm(v);
              setSelectedUser(null);
              setForm(prev => ({
                ...prev,
                account: '',
                id: null,
                fullName: '',
                phone: '',
                company: '',
                account_name: '',
                type: '',
                simType: '',
                simNetwork: '',
                paymentMethod: 'Tiền mặt',
                isNewOrder: '',
                installationType: ''
              }));
              setSelectedImages([]);
              setFetchType(v === 0 ? 'account' : 'phone');
              // Không cần gọi API ở đây vì đã có handleAutocompleteSearch khi gõ
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            style={{ marginBottom: 20, borderBottom: '1px solid #eee' }}
          >
            <Tab
              label="Đại lý"
              disabled={isEditing}
              style={{ fontWeight: 600, textTransform: 'none' }}
            />
            <Tab
              label="Khách lẻ"
              disabled={isEditing}
              style={{ fontWeight: 600, textTransform: 'none' }}
            />
          </Tabs>

          <Box
            display="flex"
            flexDirection="column"
            style={{ marginBottom: 16 }}
          >
            <Box display="flex" style={{ gap: 8, marginBottom: 8 }}>
              {tabForm === 0 && (
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ minWidth: 140 }}
                >
                  <Select
                    value={fetchType}
                    disabled={isEditing}
                    onChange={e => setFetchType(e.target.value)}
                  >
                    <MenuItem value="account">Tài khoản</MenuItem>
                    <MenuItem value="phone">Số điện thoại</MenuItem>
                  </Select>
                </FormControl>
              )}
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel
                  variant="outlined"
                  shrink
                  style={{
                    backgroundColor: 'white',
                    padding: '0 4px',
                    marginLeft: -4
                  }}
                >
                  {tabForm === 0
                    ? fetchType === 'account'
                      ? isEditing ? 'Tài khoản khách hàng' : 'Tìm tài khoản khách hàng'
                      : isEditing ? 'Số điện thoại khách hàng' : 'Tìm số điện thoại khách hàng'
                    : isEditing ? 'Số điện thoại khách hàng' : 'Tìm số điện thoại khách hàng'}
                </InputLabel>
                <Autocomplete
                  fullWidth
                  disabled={isEditing}
                  size="small"
                  options={tabForm === 0 ? listAgencies || [] : listUsers || []}
                  loading={suggestionLoading}
                  filterOptions={x => x}
                  value={selectedUser}
                  isOptionEqualToValue={(option, value) =>
                    (option.id || option.agency_id || option.user_id) ===
                    (value.id || value.agency_id || value.user_id)
                  }
                  getOptionLabel={option => {
                    if (!option) return '';
                    if (tabForm === 0) {
                      return fetchType === 'account'
                        ? option.username || option.name || ''
                        : option.leader?.phone || option.phone || '';
                    }
                    return (
                      option.phone || option.username || option.full_name || ''
                    );
                  }}
                  onInputChange={(event, newInputValue) => {
                    setForm(f => ({ ...f, account: newInputValue }));
                    handleAutocompleteSearch(newInputValue);
                    if (!newInputValue) setSelectedUser(null);
                  }}
                  onChange={(event, newValue) => {
                    setSelectedUser(newValue);
                    handleFetchUserInfo(newValue);
                  }}
                  noOptionsText={
                    suggestionLoading
                      ? 'Đang tìm kiếm...'
                      : 'Không tìm thấy kết quả'
                  }
                  renderOption={option => (
                    <Box>
                      <Typography style={{ fontWeight: 600, fontSize: 13 }}>
                        {tabForm === 0
                          ? option.name
                          : option.full_name || option.fullname}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {tabForm === 0
                          ? `${option.username || ''}${option.username ? ' - ' : ''
                          }${option.leader?.phone || option.phone || ''}`
                          : `${option.username || ''}${option.username ? ' - ' : ''
                          }${option.phone || ''}`}
                      </Typography>
                    </Box>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={
                        tabForm === 0
                          ? fetchType === 'account'
                            ? isEditing ? 'Tài khoản khách hàng' : 'Tìm tài khoản khách hàng'
                            : isEditing ? 'Số điện thoại khách hàng' : 'Tìm số điện thoại khách hàng'
                          : isEditing ? 'Số điện thoại khách hàng' : 'Tìm số điện thoại khách hàng'
                      }
                      variant="outlined"
                      InputLabelProps={{
                        ...params.InputLabelProps,
                        style: { display: 'none' }
                      }}
                    />
                  )}
                />
              </FormControl>
            </Box>
          </Box>

          <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
              >
                {tabForm === 0 ? 'Tên đại lý/công ty' : 'Tên khách hàng'}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={form.fullName}
                variant="outlined"
                size="small"
                InputProps={{ notched: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
              >
                {tabForm === 0 && fetchType === 'phone'
                  ? 'Tài khoản'
                  : 'Số điện thoại'}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={
                  tabForm === 0 && fetchType === 'phone'
                    ? form.account_name
                    : form.phone
                }
                variant="outlined"
                size="small"
                InputProps={{ notched: false }}
              />
            </Grid>
          </Grid>

          <Box mb={2}>
            <Typography
              variant="subtitle2"
              style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
            >
              Địa chỉ
            </Typography>
            <TextField
              fullWidth
              disabled
              value={form.company}
              variant="outlined"
              size="small"
              InputProps={{ notched: false }}
            />
          </Box>

          <Box mb={2}>
            <Typography
              variant="subtitle2"
              style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
            >
              Hình thức thanh toán
            </Typography>
            <FormControl fullWidth variant="outlined" size="small">
              <Select
                name="paymentMethod"
                value={form.paymentMethod || 'Tiền mặt'}
                onChange={e =>
                  setForm({ ...form, paymentMethod: e.target.value })
                }
              >
                <MenuItem value="Tiền mặt">Tiền mặt</MenuItem>
                <MenuItem value="Chuyển khoản">Chuyển khoản</MenuItem>
                {tabForm === 0 && <MenuItem value="Công nợ">Công nợ</MenuItem>}
                <MenuItem value="COD">COD</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {tabForm === 0 ? (
            <Grid container spacing={2} style={{ marginBottom: 16 }}>
              <Grid item xs={6}>
                <FormControl component="fieldset">
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: 13, color: '#666', marginBottom: 4 }}
                  >
                    Hình thức kích hoạt <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    value={form.type}
                    onChange={e => setForm({ ...form, type: e.target.value })}
                  >
                    <FormControlLabel
                      value="đại lý kích hoạt"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          Đại lý kích hoạt
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="VGPS kích hoạt"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          VGPS kích hoạt
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl component="fieldset">
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: 13, color: '#666', marginBottom: 4 }}
                  >
                    Chọn SIM <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    value={form.simType}
                    onChange={e => setForm({ ...form, simType: e.target.value })}
                  >
                    <FormControlLabel
                      value="Sim đại lý"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          Sim đại lý
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Sim VGPS"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          Sim VGPS
                        </Typography>
                      }
                    />
                  </RadioGroup>
                  {form.simType === 'Sim VGPS' && (
                    <RadioGroup
                      row
                      value={form.simNetwork}
                      onChange={e => setForm({ ...form, simNetwork: e.target.value })}
                      style={{ marginLeft: 120, marginTop: -8 }}
                    >
                      <FormControlLabel
                        value="Viettel"
                        control={<Radio color="primary" size="small" />}
                        label={
                          <Typography style={{ fontSize: 12 }}>
                            Viettel
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="Vinaphone"
                        control={<Radio color="primary" size="small" />}
                        label={
                          <Typography style={{ fontSize: 12 }}>
                            Vinaphone
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2} style={{ marginBottom: 16 }}>
              <Grid item xs={6}>
                <FormControl component="fieldset">
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: 13, color: '#666', marginBottom: 4 }}
                  >
                    Hình thức kích hoạt <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    value={form.type}
                    onChange={e => setForm({ ...form, type: e.target.value })}
                  >
                    <FormControlLabel
                      value="Khách  kích hoạt"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          Khách kích hoạt
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="VGPS kích hoạt"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          VGPS kích hoạt
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl component="fieldset">
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: 13, color: '#666', marginBottom: 4 }}
                  >
                    Chọn SIM <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    row
                    value={form.simType}
                    onChange={e => setForm({ ...form, simType: e.target.value })}
                  >
                    <FormControlLabel
                      value="Sim VGPS"
                      control={<Radio color="primary" size="small" />}
                      label={
                        <Typography style={{ fontSize: 13 }}>
                          Sim VGPS
                        </Typography>
                      }
                    />
                  </RadioGroup>
                  {form.simType === 'Sim VGPS' && (
                    <RadioGroup
                      row
                      value={form.simNetwork}
                      onChange={e => setForm({ ...form, simNetwork: e.target.value })}
                      style={{ marginLeft: 32, marginTop: -8 }}
                    >
                      <FormControlLabel
                        value="Viettel"
                        control={<Radio color="primary" size="small" />}
                        label={
                          <Typography style={{ fontSize: 12 }}>
                            Viettel
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="Vinaphone"
                        control={<Radio color="primary" size="small" />}
                        label={
                          <Typography style={{ fontSize: 12 }}>
                            Vinaphone
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12} sm={6}>
              <FormControl component="fieldset">
                <Typography
                  variant="subtitle2"
                  style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
                >
                  Hình thức lắp đặt <span style={{ color: 'red' }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  value={form.installationType}
                  onChange={e => {
                    setForm({ ...form, installationType: e.target.value });
                    if (e.target.value !== 'VGPS lắp đặt')
                      setSelectedImages([]);
                  }}
                >
                  <FormControlLabel
                    value="Khách lắp đặt"
                    control={<Radio color="primary" size="small" />}
                    label={
                      <Typography style={{ fontSize: 13 }}>
                        {tabForm === 0 ? 'Đại lý tự lắp' : 'Khách lẻ lắp'}
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="VGPS lắp đặt"
                    control={<Radio color="primary" size="small" />}
                    label={
                      <Typography style={{ fontSize: 13 }}>
                        VGPS lắp đặt
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl component="fieldset">
                <Typography
                  variant="subtitle2"
                  style={{ fontSize: 13, color: '#555', marginBottom: 4 }}
                >
                  Phân loại đơn <span style={{ color: 'red' }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  value={form.isNewOrder}
                  onChange={e =>
                    setForm({ ...form, isNewOrder: e.target.value })
                  }
                >
                  <FormControlLabel
                    value="Lắp mới "
                    control={<Radio color="primary" size="small" />}
                    label={
                      <Typography style={{ fontSize: 13 }}>Lắp mới</Typography>
                    }
                  />
                  <FormControlLabel
                    value="Thay cũ lắp mới  lấy mới"
                    control={<Radio color="primary" size="small" />}
                    label={
                      <Typography style={{ fontSize: 13 }}>
                        Thay cũ lắp mới{' '}
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Divider style={{ marginBottom: 16 }} />

          <Divider style={{ marginBottom: 16 }} />
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 600, marginBottom: 16, color: '#1a1f36' }}
          >
            Chi tiết thiết bị & Số lượng <span style={{ color: 'red' }}>*</span>
          </Typography>

          {devices.map((device, index) => (
            <Grid
              container
              spacing={2}
              key={index}
              alignItems="center"
              style={{ marginBottom: 16 }}
            >
              <Grid item xs={5}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    style={{
                      backgroundColor: 'white',
                      padding: '0 4px',
                      marginLeft: -4
                    }}
                  >
                    Loại thiết bị
                  </InputLabel>
                  <Select
                    value={device.type}
                    disabled={isEditing}
                    onChange={e =>
                      handleDeviceChange(index, 'type', e.target.value)
                    }
                    label="Loại thiết bị"
                  >
                    {listDeviceType?.map(dt => (
                      <MenuItem key={dt.id} value={dt.name}>
                        {dt.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    variant="outlined"
                    shrink
                    style={{
                      backgroundColor: 'white',
                      padding: '0 4px',
                      marginLeft: -4
                    }}
                  >
                    Số lượng
                  </InputLabel>
                  <OutlinedInput
                    disabled={isEditing}
                    label="Số lượng"
                    type="number"
                    inputProps={{ min: 1 }}
                    value={device.quantity}
                    onChange={e =>
                      handleDeviceChange(
                        index,
                        'quantity',
                        Number(e.target.value)
                      )
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    variant="outlined"
                    shrink
                    style={{
                      backgroundColor: 'white',
                      padding: '0 4px',
                      marginLeft: -4
                    }}
                  >
                    Đơn giá
                  </InputLabel>
                  <OutlinedInput
                    label="Đơn giá"
                    value={formatInputMoney(device.unitPrice || 0)}
                    onChange={e =>
                      handleDeviceChange(
                        index,
                        'unitPrice',
                        parseInputMoney(e.target.value)
                      )
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1} style={{ textAlign: 'right' }}>
                <IconButton
                  size="small"
                  color="secondary"
                  onClick={() => handleRemoveDevice(index)}
                  disabled={isEditing || devices.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}

          <Button
            startIcon={<AddCircleOutlineIcon />}
            color="primary"
            disabled={isEditing}
            onClick={handleAddDevice}
            style={{
              marginBottom: 20,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Thêm loại thiết bị khác
          </Button>

          <Box
            mt={2}
            mb={2}
            p={2}
            style={{ backgroundColor: '#f9f9f9', borderRadius: 8 }}
          >
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="body2">Tạm tính:</Typography>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {formatMoney(
                  devices.reduce((acc, d) => acc + d.quantity * d.unitPrice, 0)
                )}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                <Typography variant="body2">VAT:</Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  disabled={isEditing}
                  value={form.vat}
                  onChange={e => {
                    const v = e.target.value.replace(/[^0-9.]/g, '');
                    setForm({ ...form, vat: v === '' ? '' : Number(v) });
                  }}
                  InputProps={{
                    style: { fontSize: 13, height: 28, width: 64 },
                    endAdornment: (
                      <Typography
                        style={{ fontSize: 16, color: '#888', marginLeft: 2 }}
                      >
                        %
                      </Typography>
                    )
                  }}
                />
              </Box>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {formatMoney(
                  devices.reduce((acc, d) => acc + d.quantity * d.unitPrice, 0) *
                  ((Number(form.vat) || 0) / 100)
                )}
              </Typography>
            </Box>
            <Divider style={{ margin: '8px 0' }} />
            <Box display="flex" justifyContent="space-between">
              <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                Tiền thiết bị:
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 700, color: '#f44336' }}
              >
                {formatMoney(
                  devices.reduce((acc, d) => acc + d.quantity * d.unitPrice, 0) *
                  (1 + (Number(form.vat) || 0) / 100)
                )}
              </Typography>
            </Box>
          </Box>
          <Divider style={{ marginBottom: 16 }} />

          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel
              variant="outlined"
              shrink
              style={{
                backgroundColor: 'white',
                padding: '0 4px',
                marginLeft: -4
              }}
            >
              Ghi chú đơn hàng
            </InputLabel>
            <OutlinedInput
              multiline
              rows={2}
              label="Ghi chú đơn hàng"
              name="note"
              value={form.note}
              onChange={e => setForm({ ...form, note: e.target.value })}
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: 16 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          style={{ fontWeight: 600 }}
        >
          Hủy
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateOrder}
          style={{ fontWeight: 600 }}
        >
          {isEditing ? 'Cập nhật' : 'Hoàn Thành'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrderDialog;
